export const config = {
  title: 'Tillman Drywall Flooring and Construction | Pensacola, FL',
  meta: {
    description:
      'Tillman Drywall Flooring and Construction offers professional drywall, flooring, and construction services in Pensacola, FL. Veteran-led, reliable, and committed to excellence.',
    keywords: [
      'Tillman Drywall Flooring and Construction',
      'Drywall Contractor Pensacola',
      'Flooring Services Pensacola',
      'Construction Services Pensacola',
      'Veteran-owned Construction',
      'Residential and Commercial Construction',
    ],
    author: 'Tillman Drywall Flooring and Construction',
    canonicalUrl: 'https://www.tillmandrywallflooring.com/',
  },
  sections: {
    header: {
      businessName: 'Tillman Drywall Flooring and Construction',
    },
    sectionB: {
      heroTitle: 'Professional Drywall & Construction Services',
      heroSubtitle: 'Quality Workmanship in Pensacola, FL',
      learnAboutText: 'Learn More',
      phoneNumber: '8507416056',
      phoneLabel: '(850) 741-6056',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1175289476/photo/gypsum-board-ceiling-structure-and-plaster-mortar-wall-painted-foundation-white-decorate.jpg?s=612x612&w=0&k=20&c=MGlsjZooASkIX64yASDk_E5lw5va2g8SSkxDzKd70r0=',
      cardData: [
        {
          title: 'Drywall Installation',
          description:
            'Expert drywall services to enhance your interior spaces with precision and quality.',
        },
        {
          title: 'Flooring Solutions',
          description:
            'Transform your floors with our premium flooring services, adding elegance and durability.',
        },
        {
          title: 'Construction Projects',
          description:
            'Reliable construction services to bring your vision to life with meticulous execution.',
        },
      ],
      description:
        'At Tillman Drywall Flooring and Construction, we are committed to delivering top-quality services with a focus on customer satisfaction. Our veteran-led team ensures professionalism, reliability, and efficiency in every project.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Comprehensive solutions for all your drywall, flooring, and construction needs.',
      cards: [
        {
          title: 'Drywall Installation',
          description:
            'Custom drywall solutions to elevate the visual appeal and functionality of your property.',
          imageSrc: 'https://media.istockphoto.com/id/887501420/photo/hands-of-the-ceiling-technician.jpg?s=612x612&w=0&k=20&c=dGoLh_B3DBAsmoKXq2MvxaAsEUBNcIqnc3LutZRv9HY=',
          imageAlt: 'Drywall Installation',
        },
        {
          title: 'Flooring Services',
          description:
            'Premium flooring installations that combine elegance with durability.',
          imageSrc: 'https://media.istockphoto.com/id/2161435161/photo/installing-wood-pattern-pvc-floor.jpg?s=612x612&w=0&k=20&c=ecbxI3yiExtjf1XDG5VR7HnVku70CwZj2l1Y4BbD7Mc=',
          imageAlt: 'Flooring Services',
        },
        {
          title: 'Construction Services',
          description:
            'Expert construction services to bring your residential or commercial projects to life.',
          imageSrc: 'https://media.istockphoto.com/id/2157298355/photo/work-at-heights-a-roofer-with-tool-belt-and-save-harness-climbing-to-the-top-of-the-roof.jpg?s=612x612&w=0&k=20&c=i5v3GyGKh7H3RZhX8NxBAsYQYjF2PSlj6CVY5TQGxb8=',
          imageAlt: 'Construction Services',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Residential Construction',
        'Commercial Construction',
        'Project Management',
        'Custom Renovations',
        'Consultation Services',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/5d437a_267a3a1fed84469ea4a95993292d798a~mv2.png',
        alt: 'Tillman Drywall Flooring and Construction Team',
      },
      aboutText: [
        'Tillman Drywall Flooring and Construction is a veteran-led company based in Pensacola, FL, dedicated to providing high-quality drywall, flooring, and construction services.',
        'Our mission is to deliver reliable and efficient solutions that meet our clients\' needs, ensuring satisfaction and excellence in every project.',
      ],
    },
    sectionE: {
      profileImage: null, // Add profile image URL if available
      profileAlt: 'Tillman Drywall Flooring and Construction Logo',
      businessName: 'Tillman Drywall Flooring and Construction',
      contact: {
        phone: '8507416056',
        phoneLabel: '(850) 741-6056',
        email: 'mchaeltillman191@gmail.com',
        website: 'https://www.tillmandrywallflooring.com/',
        address: '1400 E Johnson Ave, Pensacola, FL 32514, USA',
      },
      socialMedia: {
        facebook: null, // Add Facebook URL if available
        instagram: null, // Add Instagram URL if available
        twitter: null, // Add Twitter URL if available
        linkedIn: null, // Add LinkedIn URL if available
        youtube: null, // Add YouTube URL if available
      },
    },
    sectionF: {
      address: '1400 E Johnson Ave, Pensacola, FL 32514, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3444.123456789!2d-87.123456!3d30.123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8890c1234567890%3A0x123456789abcdef!2s1400%20E%20Johnson%20Ave%2C%20Pensacola%2C%20FL%2032514%2C%20USA!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus',
    },
  },
};

export default config;
